export enum PayOptionType {
  QRCodeVNPay = 1,
  Visa,
  QRCode,
  GroceryStore,
  InternetBanking,
  Office,
}
